<ngx-spinner
  name="message"
  bdColor="rgba(40,47,57,0.85)"
  size="medium"
  color="#8bcd13"
  type="line-scale"
  class="spinner-overlay"
>
  <p style="color: white">{{ "registration.loginMessage" | translate }}</p>
</ngx-spinner>
<main class="site-content fix-height" *ngIf="registerForm">
  <div class="container signup">
    <!-- Logo -->
    <div class="logo">
      <img src="/assets/images/qunote-logo-g.svg" alt="qunote" />
    </div>
    <!-- Error Div and Message -->
    <div class="alert-message">
      <div
        class="alert alert-danger alert-dismissible fade in"
        role="alert"
        *ngIf="showFailMessage"
      >
        {{ message }}
      </div>
    </div>
    <!-- Form Headding -->
    <div class="form-heading">
      <h1>{{ "registration.signup" | translate }}</h1>
    </div>
    <!-- Form Start -->
    <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
      <p-accordion
        [expandIcon]="'pi pi-plus-circle'"
        [collapseIcon]="'pi pi-minus-circle'"
        [multiple]="true"
        [(value)]="selectedTabs"
      >
        <!-- Primary Details -->
        <p-accordion-panel [value]="1">
          <p-accordion-header>{{
            "registration.primary.heading" | translate
          }}</p-accordion-header>
          <p-accordion-content>
            <div class="height-separator"></div>
            <!-- Primary Details Row 1 -->
            <div class="input-row-flex">
              <!-- First name -->
              <div class="input-row-child">
                <input
                  tabindex="1"
                  type="text"
                  #firstName
                  placeholder="{{ 'registration.primary.fName' | translate }}"
                  class="input"
                  formControlName="first_name"
                  maxlength="50"
                  [ngClass]="{
                    'is-invalid': f.first_name.errors && f.first_name.dirty
                  }"
                />
                <!-- First Name Validations  -->
                <div
                  *ngIf="f.first_name.errors && f.first_name.dirty"
                  class="invalid-feedback"
                >
                  <div
                    *ngIf="f.first_name.errors.required"
                    class="error-message-form"
                  >
                    {{ "registration.primary.fNameRequired" | translate }}
                  </div>
                  <div
                    *ngIf="
                      !f.first_name.errors.required && f.first_name.invalid
                    "
                    class="error-message-form"
                  >
                    {{ "registration.primary.fNameInvalid" | translate }}
                  </div>
                </div>
              </div>
              {{ "" | translate }}
              <!-- Last Name -->
              <div class="input-row-child">
                <input
                  tabindex="2"
                  type="text"
                  placeholder="{{ 'registration.primary.lName' | translate }}"
                  class="input"
                  formControlName="last_name"
                  maxlength="50"
                  [ngClass]="{
                    'is-invalid': f.last_name.errors && f.last_name.dirty
                  }"
                />
                <!-- First name Validations -->
                <div
                  *ngIf="f.last_name.errors && f.last_name.dirty"
                  class="invalid-feedback"
                >
                  <div
                    *ngIf="f.last_name.errors.required"
                    class="error-message-form"
                  >
                    {{ "registration.primary.lNameRequired" | translate }}
                  </div>
                  <div
                    *ngIf="!f.last_name.errors.required && f.last_name.invalid"
                    class="error-message-form"
                  >
                    {{ "registration.primary.lNameInvalid" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <!-- Primary Details Row 2 -->
            <div class="input-row-flex">
              <!-- Email Adress  -->
              <div class="input-row-child">
                <input
                  tabindex="3"
                  type="text"
                  placeholder="{{ 'registration.primary.email' | translate }}"
                  class="input"
                  formControlName="email_address"
                  [ngClass]="{
                    'is-invalid':
                      f.email_address.errors && f.email_address.dirty
                  }"
                />
                <!-- Email Validations -->
                <div
                  *ngIf="f.email_address.errors && f.email_address.dirty"
                  class="invalid-feedback"
                >
                  <div
                    *ngIf="f.email_address.errors.required"
                    class="error-message-form"
                  >
                    {{ "registration.primary.emailRequired" | translate }}
                  </div>
                  <div
                    *ngIf="
                      (f.email_address.errors.email ||
                        f.email_address.invalid) &&
                      f.email_address.value
                    "
                    class="error-message-form"
                  >
                    {{ "registration.primary.emailInvalid" | translate }}
                  </div>
                  <div
                    *ngIf="f.email_address.errors.maxlength"
                    class="error-message-form"
                  >
                    {{ "registration.primary.emailExceed" | translate }}
                  </div>
                </div>
              </div>

              <!-- Phone Number -->
              <div class="input-row-child">
                <input
                  tabindex="4"
                  name="phone_number"
                  type="text"
                  placeholder="{{ 'registration.primary.phone' | translate }}"
                  class="input"
                  formControlName="phone_number"
                  maxlength="30"
                  [ngClass]="{
                    'is-invalid': f.phone_number.errors && f.phone_number.dirty
                  }"
                />
                <!-- Phone Number Validations -->
                <div
                  *ngIf="f.phone_number.errors && f.phone_number.dirty"
                  class="invalid-feedback"
                >
                  <div
                    *ngIf="f.phone_number.errors.required"
                    class="error-message-form"
                  >
                    {{ "registration.primary.phoneRequired" | translate }}
                  </div>
                  <div
                    *ngIf="
                      f.phone_number.invalid && !f.phone_number.errors.required
                    "
                    class="error-message-form"
                  >
                    {{ "registration.primary.phoneInvalid" | translate }}
                  </div>
                </div>
              </div>
            </div>
            <!-- Primary Details Row 3 -->
            <div class="input-row-flex">
              <!-- Column 1 -->
              <div class="input-row-child password">
                <!-- Password  -->
                <input
                  tabindex="5"
                  pPassword
                  type="password"
                  (paste)="disablePaste($event)"
                  (copy)="disablePaste($event)"
                  class="input"
                  placeholder="{{
                    'registration.primary.password' | translate
                  }}"
                  formControlName="password"
                  maxlength="255"
                  promptLabel="A valid password must contain: 8 characters or more, including upper and lowercase letters and a number."
                  [ngClass]="{
                    'is-invalid': f.password.errors && f.password.dirty
                  }"
                />
                <!-- Password Validations -->
                <div
                  *ngIf="f.password.errors && f.password.dirty"
                  class="invalid-feedback password-ack"
                >
                  <div
                    *ngIf="f.password.errors.required"
                    class="error-message-form"
                  >
                    {{ "registration.primary.passwordRequired" | translate }}
                  </div>
                  <div
                    *ngIf="f.password.errors.pattern"
                    class="error-message-form"
                  >
                    {{ "registration.primary.passwordInvalid" | translate }}
                  </div>
                </div>
              </div>
              <!-- Column 2 -->
              <div class="input-row-child">
                <!-- Confirm Password -->
                <input
                  tabindex="6"
                  type="password"
                  (paste)="disablePaste($event)"
                  (copy)="disablePaste($event)"
                  placeholder="{{
                    'registration.primary.Confirm_password' | translate
                  }}"
                  class="input"
                  formControlName="confirm_password"
                  maxlength="255"
                  [ngClass]="{
                    'is-invalid': f.password.errors && f.password.dirty
                  }"
                />
                <!-- Confirm Password Validations -->
                <div
                  *ngIf="f.confirm_password.errors && f.confirm_password.dirty"
                  class="invalid-feedback"
                >
                  <div
                    *ngIf="f.confirm_password.errors.confirm_password"
                    class="error-message-form"
                  >
                    {{
                      "registration.primary.Confirm_passwordRequired"
                        | translate
                    }}
                  </div>
                </div>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <div class="separator"></div>
        <!-- Company Details -->
        <p-accordion-panel class="company-details" [value]="2">
          <p-accordion-header>{{
            "registration.company.heading" | translate
          }}</p-accordion-header>
          <!-- Company Details -->
          <p-accordion-content>
            <div class="height-separator"></div>
            <div class="input-row-flex">
              <!-- Column 1 -->
              <div class="input-row-child">
                <div class="input-field">
                  <!-- Company Name -->
                  <input
                    type="text"
                    tabindex="7"
                    placeholder="{{
                      'registration.company.companyName' | translate
                    }}"
                    class="input"
                    formControlName="company_name"
                    maxlength="100"
                    [ngClass]="{
                      'is-invalid':
                        f.company_name.errors && f.company_name.dirty
                    }"
                  />
                  <!-- Company name validations  -->
                  <div
                    *ngIf="f.company_name.errors && f.company_name.dirty"
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="f.company_name.errors.required"
                      class="error-message-form"
                    >
                      {{
                        "registration.company.companyNameRequired" | translate
                      }}
                    </div>
                    <div
                      *ngIf="
                        f.company_name.invalid &&
                        !f.company_name.errors.required &&
                        f.company_name.status
                      "
                      class="error-message-form"
                    >
                      {{
                        "registration.company.companyNameINvalid" | translate
                      }}
                    </div>
                  </div>
                </div>

                <!-- Company Address -->
                <div class="input-field">
                  <input
                    type="text"
                    tabindex="8"
                    placeholder="{{
                      'registration.company.adress1' | translate
                    }}"
                    class="input"
                    formControlName="address_line_1"
                    maxlength="80"
                    [ngClass]="{
                      'is-invalid':
                        f.address_line_1.errors && f.address_line_1.dirty
                    }"
                  />
                  <!-- Company Address Validations -->
                  <div
                    *ngIf="f.address_line_1.errors && f.address_line_1.dirty"
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="f.address_line_1.errors.required"
                      class="error-message-form"
                    >
                      {{ "registration.company.adressRequired" | translate }}
                    </div>
                    <div
                      *ngIf="
                        f.address_line_1.invalid &&
                        !f.address_line_1.errors.required &&
                        f.address_line_1.status
                      "
                      class="error-message-form"
                    >
                      {{ "registration.company.adressInvalid" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Address Line 2 -->
                <div class="input-field">
                  <input
                    type="text"
                    tabindex="9"
                    placeholder="{{
                      'registration.company.adress2' | translate
                    }}"
                    class="input"
                    maxlength="80"
                    formControlName="address_line_2"
                  />
                </div>
                <!-- Address Line 3 -->
                <div class="input-field">
                  <input
                    type="text"
                    tabindex="10"
                    placeholder="{{
                      'registration.company.adress3' | translate
                    }}"
                    class="input"
                    maxlength="80"
                    formControlName="address_line_3"
                  />
                </div>

                <!-- Currency -->
                <div class="input-field">
                  <p-select dropdownIcon="pi pi-sort-down-fill"
                    appendTo="body"
                    tabindex="14"
                    [options]="currency"
                    optionLabel="name"
                    formControlName="currency"
                  >
                  </p-select>
                  <!-- [onChange]="changeCurrency()" -->
                </div>
              </div>
              <!-- Column 2 -->
              <div class="input-row-child">
                <!-- Town  -->
                <div class="input-field">
                  <input
                    tabindex="11"
                    type="text"
                    placeholder="{{ 'registration.company.town' | translate }}"
                    class="input"
                    formControlName="town"
                    [ngClass]="{ 'is-invalid': f.town.errors && f.town.dirty }"
                  />
                  <!-- Town Validations -->
                  <div
                    *ngIf="f.town.errors && f.town.dirty"
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="f.town.errors.required"
                      class="error-message-form"
                    >
                      {{ "registration.company.townRequired" | translate }}
                    </div>
                    <div
                      *ngIf="
                        f.town.invalid &&
                        !f.town.errors.required &&
                        f.town.status
                      "
                      class="error-message-form"
                    >
                      {{ "registration.company.townInvalid" | translate }}
                    </div>
                  </div>
                </div>
                <!-- County -->
                <div class="input-field">
                  <input
                    tabindex="12"
                    type="text"
                    placeholder="{{
                      'registration.company.country' | translate
                    }}"
                    class="input"
                    formControlName="county"
                    maxlength="30"
                    [ngClass]="{
                      'is-invalid': f.county.errors && f.county.dirty
                    }"
                  />
                  <!-- County Validations -->
                  <div
                    *ngIf="f.county.errors && f.county.dirty"
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="
                        f.county.invalid &&
                        !f.county.errors.required &&
                        f.county.status
                      "
                      class="error-message-form"
                    >
                      {{ "registration.company.countryInvalid" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Postcode  -->
                <div class="input-field">
                  <input
                    tabindex="13"
                    type="text"
                    placeholder="{{
                      'registration.company.postcode' | translate
                    }}"
                    class="input"
                    formControlName="postcode"
                    maxlength="10"
                    [ngClass]="{
                      'is-invalid': f.postcode.errors && f.postcode.dirty
                    }"
                  />
                  <!-- Postcode Validations -->
                  <div
                    *ngIf="f.postcode.errors && f.postcode.dirty"
                    class="invalid-feedback"
                  >
                    <div
                      *ngIf="f.postcode.errors.required"
                      class="error-message-form"
                    >
                      {{ "registration.company.postcodeRequired" | translate }}
                    </div>
                    <div
                      *ngIf="
                        f.postcode.invalid &&
                        !f.postcode.errors.required &&
                        f.postcode.status
                      "
                      class="error-message-form"
                    >
                      {{ "registration.company.postcodeInvalid" | translate }}
                    </div>
                  </div>
                </div>
                <!-- Counntry -->
                <div class="input-field">
                  <p-select dropdownIcon="pi pi-sort-down-fill"
                    appendTo="body"
                    tabindex="14"
                    [options]="cities1"
                    optionLabel="name"
                    formControlName="country"
                  ></p-select>
                </div>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
        <div class="separator"></div>
        <!-- Services/Professions -->
        <p-accordion-panel class="services-profession" [value]="3">
          <p-accordion-header>{{
            "registration.profession.heading" | translate
          }}</p-accordion-header>
          <p-accordion-content>
            <div class="height-separator"></div>
            <!-- Professions -->
            <p-select dropdownIcon="pi pi-sort-down-fill"
              appendTo="body"
              [options]="professions"
              class="services-profession"
              optionLabel="label"
              style="width: 100%"
              placeholder="Please choose *"
              formControlName="profession"
              (onChange)="professionChange($event)"
            >
            </p-select>
            <div [style.display]="showOthers ? '' : 'none'">
              <input
                tabindex="14"
                type="text"
                placeholder="{{
                  'registration.profession.profession' | translate
                }}"
                formControlName="other_profession"
                class="input show-others"
                maxlength="100"
              />
              <div
                *ngIf="
                  f.show_other_profession &&
                  f.other_profession.errors &&
                  f.other_profession.dirty
                "
                class="invalid-feedback"
              >
                <div
                  *ngIf="f.other_profession.errors.required"
                  class="error-message-form"
                >
                  {{ "registration.profession.profession_specify" | translate }}
                </div>
              </div>
            </div>
            <!-- Charge Rates -->
            <div class="charge-rate show-mobile">
              {{ "registration.profession.charge" | translate }}
            </div>
            <div *ngIf="registerForm['controls']['profession']['value'].name">
              <div class="form-row">
                <div class="col col-3">
                  <label>
                    <strong>Charge based on</strong>
                  </label>
                </div>
                <div class="col col-8 radio-btn">
                  <div class="radio-container">
                    <p-radioButton
                      name="billingBasis"
                      value="1"
                      formControlName="billingBasis"
                      class="radio"
                      inputId="billingBasis_1"
                    ></p-radioButton>
                    <label for="billingBasis_1">Hourly rate</label>
                  </div>
                  <div class="radio-container">
                    <p-radioButton
                      name="billingBasis"
                      value="0"
                      formControlName="billingBasis"
                      class="radio"
                      inputId="billingBasis_0"
                    ></p-radioButton>
                    <label for="billingBasis_0">Fixed fee sessions</label>
                  </div>
                </div>
              </div>
              <div
                class="form-row"
                formArrayName="items"
                *ngFor="
                  let item of registerForm.get('items')['controls'];
                  let i = index
                "
                [ngClass]="i == 0 ? 'first' : ''"
              >
                <div [formGroupName]="i">
                  <div class="col col-3">
                    <label
                      [ngClass]="i == 0 ? '' : 'hide-mobile'"
                      *ngIf="i == 0"
                      >{{ "registration.profession.charge" | translate }}</label
                    >
                    <div class="input-field">
                      <input
                        type="text"
                        formControlName="charge_name"
                        placeholder="-"
                        name=""
                        maxlength="255"
                        class="input"
                      />
                      <!-- Charge Out Rates Validations -->
                      <div class="invalid-feedback">
                        <div
                          class="error-message-form"
                          *ngIf="
                            item.controls.charge_name.invalid &&
                            item.controls.charge_name.dirty
                          "
                        >
                          {{
                            "registration.profession.chargeRequired" | translate
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Working Time -->
                  <div class="col col-3">
                    <label [ngClass]="i == 0 ? '' : 'show-mobile'"
                      >{{
                        (registerForm.get("billingBasis").value == 0
                          ? "registration.profession.FF"
                          : "registration.profession.time"
                        ) | translate
                      }}
                      <span *ngIf="registerForm.get('billingBasis').value == 1">
                        {{ "registration.profession.perHour" | translate }}
                      </span>
                      <span *ngIf="registerForm.get('billingBasis').value == 0">
                        {{ "registration.profession.perSession" | translate }}
                      </span>
                    </label>
                    <div class="input-field">
                      <input
                        name=""
                        class="input"
                        formControlName="time"
                        name="time"
                        placeholder="0.00"
                        spellcheck="true"
                        type="number"
                        min="0"
                        (blur)="setFormat('items', 'time', i)"
                        (keypress)="restrictNumbers($event)"
                      />
                      <span class="currency-sign">{{
                        f.currency.value.symbol
                      }}</span>
                      <!-- Work Time Validations -->
                      <div class="invalid-feedback">
                        <div
                          class="error-message-form"
                          *ngIf="
                            item.controls.time.invalid &&
                            item.controls.time.dirty
                          "
                        >
                          {{
                            "registration.profession.timeRequired" | translate
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Travel Time -->
                  <div class="col col-3">
                    <label [ngClass]="i == 0 ? '' : 'show-mobile'"
                      >{{ "registration.profession.travelTime" | translate }}
                      <span>
                        {{ "registration.profession.perHour" | translate }}
                      </span>
                    </label>
                    <div class="input-field">
                      <input
                        class="input"
                        formControlName="travel"
                        name="travel"
                        placeholder="0.00"
                        spellcheck="true"
                        type="number"
                        min="0"
                        (blur)="setFormat('items', 'travel', i)"
                        (keypress)="restrictNumbers($event)"
                      />
                      <span class="currency-sign">{{
                        f.currency.value.symbol
                      }}</span>
                      <!-- Travel Time Validations -->
                      <div class="invalid-feedback">
                        <div
                          class="error-message-form"
                          *ngIf="
                            item.controls.travel.invalid &&
                            item.controls.travel.dirty
                          "
                        >
                          {{
                            "registration.profession.travelTimeRequired"
                              | translate
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Mileage  -->
                  <div class="col col-3">
                    <label [ngClass]="i == 0 ? '' : 'show-mobile'">{{
                      "registration.profession.milage" | translate
                    }}</label>
                    <div class="input-field">
                      <input
                        class="input"
                        formControlName="mileage"
                        name="mileage"
                        placeholder="0.00"
                        spellcheck="true"
                        type="number"
                        min="0"
                        (blur)="setFormat('items', 'mileage', i)"
                        (keypress)="restrictNumbers($event)"
                      />
                      <span class="currency-sign">{{
                        f.currency.value.symbol
                      }}</span>
                      <!-- Mileage Validations -->
                      <div class="invalid-feedback">
                        <div
                          class="error-message-form"
                          *ngIf="
                            item.controls.mileage.invalid &&
                            item.controls.mileage.dirty
                          "
                        >
                          {{
                            "registration.profession.milageRequired" | translate
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Remove Button -->
                  <span
                    class="remove-btn"
                    title="remove"
                    (click)="removeItem(i)"
                    value="remove"
                    *ngIf="i != 0"
                  >
                    <i class="pi pi-times-circle"></i>
                  </span>
                </div>
              </div>
              <div class="form-row">
                <div class="col col-8">
                  <div class="add-btn-box">
                    <h5 class="conditions">
                      {{ "registration.profession.chargeComment" | translate }}
                    </h5>
                  </div>
                </div>
                <div class="col col-4">
                  <!-- Add Button -->
                  <div class="add-btn-box">
                    <span
                      class="add-btn btn btn-primary"
                      name=""
                      value="add"
                      (click)="addItem('', '0.00', '0.00', '0.00')"
                    >
                      {{ "registration.profession.btn" | translate }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
      <!-- Captcha -->
      <div class="submit-form">
        <div class="captcha">
          <ngx-recaptcha2
            #captchaElem
            [siteKey]="'6LcEsJEiAAAAAPJ7cB1FBXDpHWmXvMqbblVE-rc8'"
            formControlName="recaptcha"
          >
          </ngx-recaptcha2>
        </div>
        <div class="checkbox">
          <p-checkbox [formControl]="f.acceptedCheck" value="0"></p-checkbox>
          <span class="terms-and-conditions">
            {{ "registration.footer.1" | translate }}
            <a class="cursor-pointer" (click)="OpenModal()">
              {{ "registration.footer.2" | translate }}
            </a>
          </span>
        </div>
        <!-- Buttons -->
        <div class="btns">
          <input
            type="button"
            name="cancel"
            value="{{ 'registration.footer.cancel' | translate }}"
            class="btn btn-secondary cancel"
            (click)="cancel($event)"
          />
          <input
            type="submit"
            name="submit"
            value="{{ 'registration.signup' | translate }}"
            class="btn btn-secondary submit"
            [disabled]="
              !(registerForm.valid && f.acceptedCheck.value.length == 1)
            "
            [style.display]="!submitted ? '' : 'none'"
          />
        </div>
      </div>
    </form>
    <!-- Form End -->
  </div>
  <!-- Terms and Condition Modal  -->
  <p-dialog
    [focusOnShow]="false"
    header="{{ 'registration.footer.2' | translate }}"
    [(visible)]="displayTC"
    [modal]="true"
    [draggable]="false"
    [blockScroll]="true"
    styleClass="page-modal"
  >
    <div
      class="modal-body"
      [innerHTML]="pageContent.terms_conditions_page"
    ></div>
    <ng-template #footer>
      <div
        class="page-last-updated"
        [innerHTML]="
          'footer.tc_page_updated'
            | translate : { DATE: pageContent.terms_conditions_page_updated }
        "
      ></div>
      <input
        type="button"
        class="btn btn-secondary"
        value="{{ 'footer.close' | translate }}"
        (click)="closeDialog()"
      />
    </ng-template>
  </p-dialog>
</main>
<!-- Loader -->
<div class="loadercss"></div>
